export enum NotificationsActions {
  SetNotifications = '[Pending] Set Notifications',
}
